// extracted by mini-css-extract-plugin
export var fullWidthButton = "_gh-0";